import 'promise-polyfill/lib/polyfill';
import ShopifyShippingProvider from './providers/ShopifyShippingProvider';

export default class ProductService {
  constructor(type) {
    this._provider = null;
    switch (type.toLowerCase()) {
      case 'shopify': {
        this._provider = ShopifyShippingProvider;
        break;
      }
      default:
        this._provider = ShopifyShippingProvider;
    }
  }

  getShippingRates(country, province, zip) {
    return this._provider.getShippingRates(country, province, zip);
  }
}
